export default __webpack_public_path__ + "static/media/01-no junk food.028fdd4e.svg";